import { motion } from "framer-motion";
import { SERVICES } from "@/data/services";
import { fadeUp } from "./variants";

export const ServicesSection = () => {
  return (
    <section id="services" className="max-w-7xl mx-auto px-5 sm:px-8 py-28">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-6 mb-14">
        <div className="w-full text-center">
          <p className="text-sm tracking-[0.2em] uppercase font-semibold text-brand-dark mb-3">What we do</p>
          <h2 className="text-3xl sm:text-5xl font-heading font-extrabold tracking-tight max-w-2xl mx-auto text-brand-dark">
            Six specialized services, one trusted partner.
          </h2>
        </div>
      </div>

      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
        {SERVICES.map((s, i) => (
          <motion.div key={s.id} initial="hidden" whileInView="show" viewport={{ once: true }} custom={i} variants={fadeUp}
            data-testid={`service-card-${s.id}`}
            className="group relative rounded-lg bg-brand-card border border-gray-200 overflow-hidden shadow-sm hover:shadow-xl hover:border-brand-blue/40 transition-all duration-300 hover:-translate-y-1">
            <div className="h-44 overflow-hidden relative bg-white">
              <img src={s.image} alt={s.name} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <h3 className="text-xl font-heading mb-2 text-brand-dark">{s.name}</h3>
              <p className="text-base font-medium text-gray-600 leading-relaxed line-clamp-3">{s.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
